import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sprintf } from 'sprintf-js';
import styled, { css } from 'styled-components';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"styled-system"' has no exported member 'T... Remove this comment to see the full error message
import { Transition } from 'styled-system';

import { CurrentUser } from 'api/currentUser';
import { Notification } from 'api/userNotifications';
import Box from 'components/Box';
import { LinkButton, PrimaryButtonRouterLink } from 'components/Button';
import Divider from 'components/Divider';
import Meter from 'components/Meter';
import Notifications from 'components/Notifications';
import DropdownMenu, {
  DropdownMenuItem,
  DropdownMenuItemRouter,
  DropdownMenuSection,
  DropdownMenuSectionItemRouter,
  DropdownMenuSectionTitle,
} from 'components/PageHeaderDropdownMenu';
import PostListingLink from 'components/PostListingLink';
import { Link as RouterLink } from 'components/RouterLink';
import Text from 'components/Text';
import UserNotification from 'components/UserNotification';
import ResumeDatabaseResponseContainer from 'containers/ResumeDatabaseResponseContainer';
import { trackClicked, trackEvent } from 'utils/analytics';
import { hasUsedAts } from 'utils/ats';
import { isDefined } from 'utils/functional/type';
import {
  NOTIFICATIONS,
  dismissNotification as dismissLocalNotification,
  notificationIsDismissed,
} from 'utils/localNotifications';
import { hasResumeDb, promoteResumeDatabase } from 'utils/resumeDatabase';
import { promoteSalarySurvey } from 'utils/salarySurvey';

import {
  dismissNotifications,
  fetchNotifications,
} from '../redux/main/actions/userNotifications';
import { colors, fontWeights, transition } from '../theme';

const NAV_WIDTH = {
  en: 900,
  es: 1050,
  pt: 1000,
};

const getCount = (notifications: Array<Notification>) =>
  notifications.reduce(
    (acc, n) =>
      n.type === 'NEW_APPLICATIONS_BY_LISTING' ? acc + n.data.count : acc + 1,
    0
  );

const linkStyles = css`
  text-decoration: underline;
  white-space: nowrap;
  font-weight: ${fontWeights.semiBold};
`;
const StyledRouterLink = styled(RouterLink)`
  ${linkStyles}
`;
const StyledPostListingLink = styled(PostListingLink)`
  ${linkStyles}
`;
const StyledLinkButton = styled(LinkButton)`
  color: ${colors.battleshipGrey};
  font-size: inherit;
  font-weight: ${fontWeights.normal};
  text-decoration: underline;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ConditionalDropdownMenuItem = ({
  to,
  isStaff,
  ...props
}: {
  to: string;
  isStaff?: boolean;
}) => {
  const Component = isStaff ? DropdownMenuItem : DropdownMenuItemRouter;
  const linkProps = isStaff
    ? {
        href: to,
      }
    : {
        to,
      };
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} {...linkProps} />;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Badge = ({
  count,
  ...props
}: Transition & {
  count: number | null | undefined;
}) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    width="calc(1em + 4px)"
    height="calc(1em + 4px)"
    flex="0 0 auto"
    borderRadius="50%"
    color="white"
    fontWeight={isDefined(count) ? fontWeights.normal : fontWeights.bold}
    lineHeight={1.375}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line no-nested-ternary */}
    <Box fontSize={`calc(1em - ${!count ? 1 : count > 9 ? 2 : 0}px)`}>
      {!isDefined(count) ? '!' : Math.min(count, 99)}
      {count && count > 99 && '+'}
    </Box>
  </Box>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ProfileSection = ({
  closeMenu,
  currentUser,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeMenu: (...args: Array<any>) => any;
  currentUser: CurrentUser;
}) => (
  <>
    <Divider light my={0} />
    <Box minWidth={200} px={12} pt={16} pb={24} textAlign="center">
      <Box mb="8px" color={colors.battleshipGrey}>
        {getText('Your profile is incomplete')}
      </Box>
      <Meter
        current={1}
        total={3}
        color="turtleGreen"
        delay={0}
        duration={0.5}
      />
      <Box mt={20} mb="8px">
        <PrimaryButtonRouterLink
          to="/dashboard/employment-profile/get-discovered"
          size="small"
          square
          width="100%"
          onClick={() => {
            closeMenu();
            trackClicked('Add Resume', {
              context: 'Header User Dropdown',
            });
          }}
        >
          {currentUser.resumeId
            ? getText('Share Resume')
            : getText('Add Resume')}
        </PrimaryButtonRouterLink>
      </Box>
      <Box width={1} display="flex" flexDirection="column" alignItems="center">
        {/* @ts-expect-error ts-migrate(2786) FIXME: 'ResumeDatabaseResponseContainer' cannot be used a... Remove this comment to see the full error message */}
        <ResumeDatabaseResponseContainer>
          {({ dismiss }) => (
            <StyledLinkButton
              onClick={() => {
                dismiss();
                closeMenu();
                trackClicked('Dismiss Resume Database CTA', {
                  context: 'Header User Dropdown',
                });
              }}
            >
              {getText('No, thanks')}
            </StyledLinkButton>
          )}
        </ResumeDatabaseResponseContainer>
      </Box>
    </Box>
  </>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const AtsCtaNotification = ({
  dismiss,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dismiss: (...args: Array<any>) => any;
}) => (
  <Box p={12} minWidth={260} borderTop={`1px solid ${colors.aluminum}`}>
    <UserNotification status="NEW" dismiss={dismiss}>
      <Text
        dangerouslySetInnerHTML={{
          __html: sprintf(
            getText(`One more reason to post on Idealist:
              Try%(nonBreakingSpace)sour free Applicant Tracker%(nonBreakingSpace)stoday!`),
            {
              nonBreakingSpace: '&nbsp;',
            }
          ),
        }}
      />

      <Box display="flex" mt={16}>
        <StyledRouterLink to={getText('/applicant-tracker')} onClick={dismiss}>
          {getText('Learn More')}
        </StyledRouterLink>
        <Box mx="8px" width="1px" bg={colors.aluminum} />
        <StyledPostListingLink
          data-qa-id="post-a-listing-ats-dropdown"
          onClick={() => {
            trackClicked('Post A Listing', {
              context: 'User Dropdown ATS CTA',
            });
            dismiss();
          }}
        >
          {getText('Post a Listing')}
        </StyledPostListingLink>
      </Box>
    </UserNotification>
  </Box>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const PageHeaderAccountDropdown = ({
  currentUser,
  isStaff,
}: {
  currentUser: CurrentUser;
  isStaff: boolean;
}) => {
  const dispatch = useDispatch();
  const { userNotifications } = useSelector((state) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'userNotifications' does not exist on typ... Remove this comment to see the full error message
    userNotifications: state.userNotifications,
  }));
  const [atsNotificationDismissed, setAtsNotificationDismissed] = useState(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    notificationIsDismissed(NOTIFICATIONS.ORG_ADMIN_USER_DROPDOWN_ATS_CTA)
  );
  const isAdmin = currentUser.orgs && currentUser.orgs.length > 0;
  const promoteResumeDb = promoteResumeDatabase({
    currentUser,
  });
  const showSalarySurveyLink = promoteSalarySurvey({
    currentUser,
  });
  const promoteAts = isAdmin && !atsNotificationDismissed && !hasUsedAts();
  const showBadge =
    promoteResumeDb ||
    promoteAts ||
    (userNotifications.notifications &&
      userNotifications.notifications.length > 0);

  const dismissAtsNotification = () => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    dismissLocalNotification(NOTIFICATIONS.ORG_ADMIN_USER_DROPDOWN_ATS_CTA);
    setAtsNotificationDismissed(true);
  };

  const dismissNotification = (ids) => {
    dispatch(dismissNotifications(ids));
  };

  useEffect(() => {
    if (currentUser.hasNotifications && !userNotifications.isLoaded) {
      dispatch(fetchNotifications());
    }
  }, [currentUser.hasNotifications, dispatch, userNotifications.isLoaded]);

  const openMenu = (_, isOpen) => {
    if (isOpen && showSalarySurveyLink) {
      trackEvent('Displayed: Salary Survey Ad', {
        context: 'User Menu',
      });
    }
  };

  return (
    <Box position="relative">
      <DropdownMenu
        aria-label={getText('Account Information')}
        onClick={openMenu}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/no-unstable-nested-components
        title={() => (
          <Box
            display={['none', null, null, 'flex']}
            alignItems="center"
            maxWidth={[
              null,
              null,
              null,
              `calc(100vw - ${NAV_WIDTH[USER_LOCALE]}px)`,
            ]}
            minWidth={[null, null, null, 32]}
          >
            <Box
              whiteSpace="noWrap"
              textOverflow="ellipsis"
              overflow="hidden"
              pl={showBadge && 'calc(1em + 10px)'}
            >
              {
                /* TRANSLATORS: user greeting at top of page */
                sprintf(getText('Hi, %(name)s!'), {
                  name: currentUser.firstName || currentUser.email,
                })
              }
            </Box>
          </Box>
        )}
        data-qa-id="nav-dropdown"
      >
        {({ closeMenu, open }) => (
          <>
            {promoteResumeDb && (
              <ProfileSection closeMenu={closeMenu} currentUser={currentUser} />
            )}

            {userNotifications.isLoaded && userNotifications.notifications && (
              <Notifications
                notifications={userNotifications.notifications}
                dismiss={dismissNotification}
                open={open}
              />
            )}

            {promoteAts && (
              <AtsCtaNotification dismiss={dismissAtsNotification} />
            )}

            {showSalarySurveyLink && (
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; to: string; isStaff: boo... Remove this comment to see the full error message
              <ConditionalDropdownMenuItem
                to="/survey"
                isStaff={isStaff}
                onClick={() => {
                  trackClicked('Clicked: Salary Survey Ad', {
                    cta_type: 'Link',
                    button_text: 'Take Our Salary Survey',
                    url: '/survey',
                    context: 'User Menu',
                  });
                }}
              >
                {getText('Take Our Salary Survey')}
              </ConditionalDropdownMenuItem>
            )}

            {hasResumeDb(currentUser) && (
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; to: string; isStaff: boo... Remove this comment to see the full error message
              <ConditionalDropdownMenuItem
                to="/dashboard/employment-profile"
                isStaff={isStaff}
                onClick={closeMenu}
              >
                {getText('Employment Profile')}
              </ConditionalDropdownMenuItem>
            )}

            {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; to: string; isStaff: boo... Remove this comment to see the full error message */}
            <ConditionalDropdownMenuItem
              to="/dashboard/account-settings"
              isStaff={isStaff}
              onClick={closeMenu}
            >
              {getText('My Account')}
            </ConditionalDropdownMenuItem>

            {currentUser.orgs.length > 0 && (
              <DropdownMenuSection>
                <DropdownMenuSectionTitle>
                  {getText('My Organizations')}
                </DropdownMenuSectionTitle>
                {currentUser.orgs.map((org) =>
                  isStaff ? (
                    <DropdownMenuItem
                      key={org.id}
                      href={
                        org.hasGradProgram && !org.overrideToMainDashboard
                          ? `/admin/${org.id}/grad-program`
                          : `/admin/${org.id}`
                      }
                      onClick={closeMenu}
                    >
                      {org.name}
                    </DropdownMenuItem>
                  ) : (
                    <DropdownMenuSectionItemRouter
                      key={org.id}
                      to={
                        org.hasGradProgram && !org.overrideToMainDashboard
                          ? `/admin/${org.id}/grad-program`
                          : `/admin/${org.id}`
                      }
                      onClick={closeMenu}
                    >
                      {org.name}
                    </DropdownMenuSectionItemRouter>
                  )
                )}
              </DropdownMenuSection>
            )}

            {currentUser.groups.length > 0 && (
              <DropdownMenuSection>
                <DropdownMenuSectionTitle>
                  {getText('My Groups')}
                </DropdownMenuSectionTitle>
                {currentUser.groups.map((group) => (
                  <DropdownMenuSectionItemRouter
                    key={group.id}
                    to={`/group-admin/${group.id}`}
                    onClick={closeMenu}
                  >
                    {group.name}
                  </DropdownMenuSectionItemRouter>
                ))}
              </DropdownMenuSection>
            )}

            <DropdownMenuItem href="/logout" data-qa-id="logout-link">
              {getText('Log Out')}
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenu>

      {showBadge && (
        <Box
          position="absolute"
          zIndex={2000}
          left={12}
          top={11}
          pointerEvents="none"
        >
          <Badge
            data-qa-id={
              userNotifications.notifications &&
              userNotifications.notifications.length
                ? 'notification-count'
                : 'notification-icon'
            }
            bg={
              userNotifications.notifications &&
              userNotifications.notifications.length
                ? colors.poppy
                : colors.waterBlue
            }
            transition={`all ${transition}`}
            count={
              userNotifications.notifications &&
              userNotifications.notifications.length
                ? getCount(userNotifications.notifications)
                : null
            }
          />
        </Box>
      )}
    </Box>
  );
};

export default PageHeaderAccountDropdown;
